import { render } from "./NavItemProfile.vue?vue&type=template&id=1d88eb94&scoped=true"
import script from "./NavItemProfile.vue?vue&type=script&lang=js"
export * from "./NavItemProfile.vue?vue&type=script&lang=js"

import "./NavItemProfile.vue?vue&type=style&index=0&id=1d88eb94&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d88eb94"]])

export default __exports__